export const CONSTANT = {
	REQUIRED: 'Campo obbligatorio',
	NULLABLE: 'Campo obbligatorio',
	ACTION_ADD: 'Aggiungi',
	ACTION_CREATE: 'Crea',
	ACTION_SAVE: 'Salva',
	ACTION_DELETE: 'Cancella',
	REC_NEW: 'Nuovo',
	REC_UPDATE: 'Modifica',
	YEAR: 'Inserire anno corretto',
	EMAIL: 'Formato Email non corretto',
	NUMBER_POSITIVE: 'Inserire un valore positivo',
	NUMBER: 'Inserire un valore numerico',
	INTEGER: 'Inserire un valore intero',
	CURRENT_YEAR: new Date().getFullYear(),
	CURRENT_MONTH: new Date().getMonth(),
	MOCK_DELAY: 1000,
	MOCK_ENABLED: false,
	STEP: 'STEP',
	INIT: 'INIT',
	DOCUMENT_REQUIRED: 'Inserisci il documento',
	PIC_REQUIRED: 'Inserisci la foto',
	FISCAL_CODE: 'Codice fiscale non corretto',
	VAT_CODE: 'Partita iva non corretta'
};

export const ENUM_AGGREGATION_TYPE = [
	{
		label: `COMUNITA' ENERGETICA RINNOVABILE`,
		code: 'CER'
	},
	{
		label: 'AUTOCONSUMO COLLETTIVO',
		code: 'AUC'
	}
];

export const ENUM_STATUS_PARTECIPANT = [
	{
		label: 'ATTIVO',
		code: 'ACT'
	},
	{
		label: 'ARCHIVIATO',
		code: 'ARC'
	}
];

export const CONSTANT_SERVICE = {
	OFFERS: 'offers',
	TAGS: 'tags',
	WORKFLOW: 'workflow'
};

export const STATUS = {
	OK: 200,
	ERROR: 500
};

export const STORAGE_KEYS = {
    BE_CONFIG: 'beConfig'
}

export const MESSAGE = {
	SUCCESS_DOC_SAVE: 'Documenti correttamente salvati',
	SUCCESS_SAVE: 'Dati correttamente salvati',
	SUCCESS_EDIT: 'Dati correttamente aggiornati',
	ERROR: 'Ops! Qualcosa è andato storto'
};

export const FILES = {
	ABUSI: 'abusi',
	AGIBILITA: 'agibilita',
	ALLEGATI_CD_110: 'allegati_cd_110',
	ALLEGATI_CD_Sisma: 'allegati_cd_sisma',
	ALLEGATOB_1: 'allegatoB_1',
	ALLEGATOB_2: 'allegatoB_2',
	ALLEGATOB_3: 'allegatoB_3',
	ALTRI_ALLEGATI: 'altri_allegati',
	ALTRI_ALLEGATI_COMUNE: 'altri_allegati_comune',
	ALTRI_ALLEGATI_COMUNE_50: 'altri_allegati_comune_50',
	ALTRI_ALLEGATI_COMUNE_: 'altri_allegati_comune_',
	ALTRI_ALLEGATI_COMUNE__50: 'altri_allegati_comune__50',
	ALTRI_ALLEGATI_COMUNE__Sisma: 'altri_allegati_comune__Sisma',
	ALTRI_ALLEGATI_COMUNE_Sisma: 'altri_allegati_comune_Sisma',
	ALTRI_DOCUMENTI: 'altri-documenti',
	ANNESSI_CONTRATTO_SUBAPPALTO: 'annessi_contratto_subappalto',
	ANNESSI_DAPPALTO: 'annessi_dappalto',
	ANNESSI_DAPPALTO_50: 'annessi_dappalto_50',
	ANNESSI_DAPPALTO_: 'annessi_dappalto_',
	ANNESSI_DAPPALTO__50: 'annessi_dappalto__50',
	ANNESSI_DAPPALTO__Sisma: 'annessi_dappalto__Sisma',
	ANNESSI_DAPPALTO_Sisma: 'annessi_dappalto_Sisma',
	ANTIFRODE: 'antifrode',
	APE_POSTINTERVENTO: 'ape_postintervento',
	APE_POSTINTERVENTO_110: 'ape_postintervento_110',
	APE_POSTINTERVENTO_SISMA: 'ape_postintervento_sisma',
	APE_PREINTERVENTO: 'ape_preintervento',
	ASSEVERAZIONE_110: 'asseverazione_110',
	ASSEVERAZIONE_Sisma: 'asseverazione_Sisma',
	ASSEVEREAZIONE_ENEA_110: 'assevereazione_enea_110',
	ASSEVEREAZIONE_ENEA_Sisma: 'assevereazione_enea_sisma',
	ATTESTAZIONE_IMPRESA_LAVORI_110: 'attestazione_impresa_lavori_110',
	ATTESTAZIONE_IMPRESA_LAVORI_SISMA: 'attestazione_impresa_lavori_sisma',
	ATTESTAZIONE_REDDITO: 'attestazione_reddito',
	ATTESTAZIONE_TRASFERIMENTO_110: 'attestazione_trasferimento_110',
	ATTESTAZIONE_TRASFERIMENTO_Sisma: 'attestazione_trasferimento_sisma',
	ATTO_PROPRIETA: 'atto_propr',
	AUTODICHIARAZIONE: 'autodichiarazione',
	AUTODICHIARAZIONE_BENEFICIARIO_110: 'autodichiarazione_beneficiario_110',
	AUTODICHIARAZIONE_BENEFICIARIO_Sisma:'autodichiarazione_beneficiario_Sisma',
	BOLLETTA_E: 'bolletta_energia_elettrica',
	BOLLETTA_G: 'bolletta_combustibile',
	BONIFICI_110: 'bonifici_110',
	BONIFICI_Sisma: 'bonifici_sisma',
	CALDAIA: 'caldaia',
	CF: 'codice_fiscale',
	CI: 'documento_identita',
	CI_BENEFICIARI: 'documento_identita_beneficiari',
	CI_DIRETTORE_110: 'ci_direttore_110',
	CI_DIRETTORE_Sisma: 'ci_direttore_sisma',
	CI_ISCRIZIONE_TECNICI_110:  'ci_iscrizione_tecnici_110',
	CI_ISCRIZIONE_TECNICI_Sisma:  'ci_iscrizione_tecnici_Sisma',
	CILA: 'cila',
	CILA_50: 'cila_50',
	CILA_: 'cila_',
	CILA__50: 'cila__50',
	CILA__Sisma: 'cila__Sisma',
	CILA_Sisma: 'cila_Sisma',
	COMPUTO_METRICO: 'computo-metrico',
	COMUNICAZIONE_ASL_110: 'comunicazione_asl_110',
	COMUNICAZIONE_ASL_Sisma: 'comunicazione_asl_sisma',
	CONDIZIONI_SOSPENSIVE_110: 'condizioni_sospensive_110',
	CONDIZIONI_SOSPENSIVE_Sisma: 'condizioni_sospensive_sisma',
	CONFORMITA: 'conformita_urbanistica',
	CONFORMITA_OPERE_B1: 'conformita_opere_b1',
	CONFORMITA_OPERE_B2: 'conformita_opere_b2',
	CONFORMITA_SAL_110: 'conformita_sal_110',
	CONFORMITA_SAL_Sisma: 'conformita_sal_sisma',
	CONSENSO_GDPR: 'consenso_gdpr',
	CONSENSO_PROPRIETARIO: 'consenso_proprietario',
	CONTRATTO_CESSIONE_GSE_110: 'contratto_cessione_gse_110',
	CONTRATTO_CESSIONE_GSE_SISMA: 'contratto_cessione_gse_sisma',
	CONTRATTO_F4E_PROFESSIONISTI: 'contratto_f4e_professionisti',
	CONTRATTO_SUBAPPALTO: 'contratto_subappalto',
	DELEGA: 'delega',
	DELEGA_TRASFERIMENTO_BANCA_110: 'delega_trasferimento_banca_110',
	DELEGA_TRASFERIMENTO_BANCA_Sisma: 'delega_trasferimento_banca_sisma',
	DELEGA_TRASFERIMENTO_CREDITO_110: 'delega_trasferimento_credito_110',
	DELEGA_TRASFERIMENTO_CREDITO_Sisma: 'delega_trasferimento_credito_sisma',
	DELIBERA_ASSEMBLEARE_110: 'delibera_assembleare_110',
	DELIBERA_ASSEMBLEARE_SISMA: 'delibera_assembleare_sisma',
	DETTAGLIO_IMPORTI_110: 'dettaglio_importi_110',
	DETTAGLIO_IMPORTI_Sisma: 'dettaglio_importi_Sisma',
	DICHIARAZIONE_CONFORMITA_110: 'dichiarazione_conformita_110',
	DICHIARAZIONE_CONFORMITA_Sisma: 'dichiarazione_conformita_Sisma',
	DICHIARAZIONE_FINE_LAVORI_110: 'dichiarazione_fine_lavori_110',
	DICHIARAZIONE_FINE_LAVORI_Sisma: 'dichiarazione_fine_lavori_Sisma',
	DICHIARAZIONE_INIZIO_LAVORI_110: 'dichiarazione_inizio_lavori_110',
	DICHIARAZIONE_INIZIO_LAVORI_Sisma: 'dichiarazione_inizio_lavori_sisma',
	DICHIARAZIONE_SISMABONUS: 'dichiarazione_sismabonus',
	DICHIARAZIONE_SOSTITUTIVA_110: 'dichiarazione_sostitutiva_110',
	DICHIARAZIONE_SOSTITUTIVA_Sisma: 'dichiarazione_sostitutiva_Sisma',
	DICHIARAZIONE_VINCOLI: 'dichiarazione_vincoli',
	DOCUMENTI_AGGIUNTIVI: 'documenti_aggiuntivi',
	DOCUMENTI_AGGIUNTIVI_50: 'documenti_aggiuntivi_50',
	DOCUMENTI_AGGIUNTIVI_Sisma: 'documenti_aggiuntivi_Sisma',
	DOCUMENTO_FIRMATO_CONTRATTO: 'doc-contr-sign',
	DOCUMENTO_FIRMATO_CONTRATTO_50: 'doc-contr-sign_50',
	DOCUMENTO_FIRMATO_CONTRATTO_: 'doc-contr-sign_',
	DOCUMENTO_FIRMATO_CONTRATTO__50: 'doc-contr-sign__50',
	DOCUMENTO_FIRMATO_CONTRATTO__Sisma: 'doc-contr-sign__Sisma',
	DOCUMENTO_FIRMATO_CONTRATTO_Sisma: 'doc-contr-sign_Sisma',
	DOCUMENTO_FIRMATO_PRE_CONTRATTO: 'preContrattoFirmato',
	EDIFICIO_EXT: 'edificio_esterno',
	ELEMENTI_RADIANTI: 'elementi_radianti',
	ELEMENTO_AUTORISCALDANTE: 'elemento_autoriscaldante',
	FATTURE_110: 'fatture_110',
	FATTURE_Sisma: 'fatture_sisma',
	FILE_OPZIONE_SCONTO_110: 'file_opzione_sconto_110',
	FILE_OPZIONE_SCONTO_Sisma: 'file_opzione_sconto_sisma',
	FINESTRE: 'finestre',
	FOTO_ANTE_INTERVENTO: 'foto_ante_intervento',
	FOTO_ESTERNE: 'foto_esterne',
	FOTO_POSTLAVORI_110: 'foto_postlavori_110',
	FOTO_POSTLAVORI_SISMA: 'foto_postlavori_sisma',
	LETTERA_INCARICO_DIRETTORE_110: 'lettera_incarico_direttore_110',
	LETTERA_INCARICO_DIRETTORE_Sisma: 'lettera_incarico_direttore_sisma',
	LETTERA_INCARICO_TECNICI_110: 'lettera_incarico_tecnici_110',
	LETTERA_INCARICO_TECNICI_Sisma: 'lettera_incarico_tecnici_Sisma',
	LIBRETTO: 'libretto',
	LINK_INSERIMENTO_PIN_110: 'link_inserimento_pin_110',
	LINK_INSERIMENTO_PIN_Sisma: 'link_inserimento_pin_sisma',
	MODELLO_OPZIONE_SCONTO_110: 'modello_opzione_sconto_110',
	MODELLO_OPZIONE_SCONTO_FIRMATO_110: 'modello_opzione_sconto_firmato_110',
	MODELLO_OPZIONE_SCONTO_FIRMATO_Sisma: 'modello_opzione_sconto_firmato_sisma',
	MODELLO_OPZIONE_SCONTO_Sisma: 'modello_opzione_sconto_sisma',
	MURI: 'muri',
	NOMINA_CONDOMINIO_110: 'nomina_condominio_110',
	NOMINA_CONDOMINIO_SISMA: 'nomina_condominio_sisma',
	PLANIMETRIA: 'planimetria',
	POLIZZA: 'polizza',
	POLIZZA_B1: 'polizza_b1',
	POLIZZA_B2: 'polizza_b2',
	PORTE: 'porte_interne',
	PRATICHE_EDILIZIE: 'pratiche_edilizie',
	PROGETTO_ESECUTIVO: 'progetto-esecutivo',
	PROGETTO_PRELIMINARE: 'progetto-preliminare',
	PROVA_PAGAMENTO_ENEA_110: 'prova_pagamento_enea_110',
	PROVA_PAGAMENTO_ENEA_Sisma: 'prova_pagamento_enea_sisma',
	PROVA_PAGAMENTO_PREMIO_TECNICO_B1: 'prova_pagamento_premio_tecnico_b1',
	PROVA_PAGAMENTO_PREMIO_TECNICO_B2: 'prova_pagamento_premio_tecnico_b2',
	RELAZIONE: 'relazione',
	REQUIRED_VERIFY: 'verifica',
	RICEVUTA_DEPOSITO_MODELLI: 'ricevuta_deposito_modelli',
	RICEVUTA_INVIO_OPZIONE_SCONTO_110: 'ricevuta_invio_opzione_sconto_110',
	RICEVUTA_INVIO_OPZIONE_SCONTO_Sisma: 'ricevuta_invio_opzione_sconto_sisma',
	SAL_SISMABONUS: 'sal_sismabonus',
	SCHEDA_CALDAIA: 'scheda_caldaia',
	SCHEDA_COMMESSA: 'scheda_commessa',
	STRATIGAFIA_CALCOLI: 'stratigrafia-e-calcoli',
	TABELLA_RIPARTIZIONE_SPESE_110: 'tabella_ripartizione_spese_110',
	TABELLA_RIPARTIZIONE_SPESE_SISMA: 'tabella_ripartizione_spese_sisma',
	TAVOLE: 'tavole',
	TITOLO_DISPONIBILITA: 'titolo_disponibilita',
	TRASMISSIONE_ASSEVERAZIONE_110: 'trasmissione_asseverazione_110',
	TRASMISSIONE_ASSEVERAZIONE_Sisma: 'trasmissione_asseverazione_sisma',
	VINCOLI: 'vincoli',
	VISURA: 'visura',
	WEBFORM_110: 'webform_110',
	WEBFORM_Sisma: 'webform_sisma',

	ASSEVEREAZIONE_ENEA_110_2: 'assevereazione_enea_110_2',
	ASSEVEREAZIONE_ENEA_110_3: 'assevereazione_enea_110_3',
	ASSEVEREAZIONE_ENEA_Sisma_2: 'assevereazione_enea_sisma_2',
	ASSEVEREAZIONE_ENEA_Sisma_3: 'assevereazione_enea_sisma_3',
	ATTESTAZIONE_TRASFERIMENTO_110_2: 'attestazione_trasferimento_110_2',
	ATTESTAZIONE_TRASFERIMENTO_110_3: 'attestazione_trasferimento_110_3',
	ATTESTAZIONE_TRASFERIMENTO_Sisma_2: 'attestazione_trasferimento_sisma_2',
	ATTESTAZIONE_TRASFERIMENTO_Sisma_3: 'attestazione_trasferimento_sisma_3',
	BONIFICI_110_2: 'bonifici_110_2',
	BONIFICI_110_3: 'bonifici_110_3',
	BONIFICI_Sisma_2: 'bonifici_sisma_2',
	BONIFICI_Sisma_3: 'bonifici_sisma_3',
	CONDIZIONI_SOSPENSIVE_110_2: 'condizioni_sospensive_110_2',
	CONDIZIONI_SOSPENSIVE_110_3: 'condizioni_sospensive_110_3',
	CONDIZIONI_SOSPENSIVE_Sisma_2: 'condizioni_sospensive_sisma_2',
	CONDIZIONI_SOSPENSIVE_Sisma_3: 'condizioni_sospensive_sisma_3',
	CONFORMITA_SAL_110_2: 'conformita_sal_110_2',
	CONFORMITA_SAL_Sisma_2: 'conformita_sal_sisma_2',
	FATTURE_110_2: 'fatture_110_2',
	FATTURE_110_3: 'fatture_110_3',
	FATTURE_Sisma_2: 'fatture_sisma_2',
	FATTURE_Sisma_3: 'fatture_sisma_3',
	FILE_OPZIONE_SCONTO_110_2: 'file_opzione_sconto_110_2',
	FILE_OPZIONE_SCONTO_110_3: 'file_opzione_sconto_110_3',
	FILE_OPZIONE_SCONTO_Sisma_2: 'file_opzione_sconto_sisma_2',
	FILE_OPZIONE_SCONTO_Sisma_3: 'file_opzione_sconto_sisma_3',
	MODELLO_OPZIONE_SCONTO_110_2: 'modello_opzione_sconto_110_2',
	MODELLO_OPZIONE_SCONTO_110_3: 'modello_opzione_sconto_110_3',
	MODELLO_OPZIONE_SCONTO_FIRMATO_110_2: 'modello_opzione_sconto_firmato_110_2',
	MODELLO_OPZIONE_SCONTO_FIRMATO_110_3: 'modello_opzione_sconto_firmato_110_3',
	MODELLO_OPZIONE_SCONTO_FIRMATO_Sisma_2: 'modello_opzione_sconto_firmato_sisma_2',
	MODELLO_OPZIONE_SCONTO_FIRMATO_Sisma_3: 'modello_opzione_sconto_firmato_sisma_3',
	MODELLO_OPZIONE_SCONTO_Sisma_2: 'modello_opzione_sconto_sisma_2',
	MODELLO_OPZIONE_SCONTO_Sisma_3: 'modello_opzione_sconto_sisma_3',
	RICEVUTA_INVIO_OPZIONE_SCONTO_110_2: 'ricevuta_invio_opzione_sconto_110_2',
	RICEVUTA_INVIO_OPZIONE_SCONTO_110_3: 'ricevuta_invio_opzione_sconto_110_3',
	RICEVUTA_INVIO_OPZIONE_SCONTO_Sisma_2: 'ricevuta_invio_opzione_sconto_sisma_2',
	RICEVUTA_INVIO_OPZIONE_SCONTO_Sisma_3: 'ricevuta_invio_opzione_sconto_sisma_3',
	SAL_SISMABONUS_2: 'sal_sismabonus_2',
	SAL_SISMABONUS_3: 'sal_sismabonus_3',
	TABELLA_IMPORTI_110: 'tabella_importi_110',
	TABELLA_IMPORTI_110_2: 'tabella_importi_110_2',
	TABELLA_IMPORTI_110_3: 'tabella_importi_110_3',
	TABELLA_IMPORTI_110_4: 'tabella_importi_110_4',
	TABELLA_IMPORTI_SISMA: 'tabella_importi_sisma',
	TABELLA_IMPORTI_SISMA_2: 'tabella_importi_sisma_2',
	TABELLA_IMPORTI_SISMA_3: 'tabella_importi_sisma_3',
	TABELLA_IMPORTI_SISMA_4: 'tabella_importi_sisma_4',
	TRASMISSIONE_ASSEVERAZIONE_110_2: 'trasmissione_asseverazione_110_2',
	TRASMISSIONE_ASSEVERAZIONE_110_3: 'trasmissione_asseverazione_110_3',
	TRASMISSIONE_ASSEVERAZIONE_Sisma_2: 'trasmissione_asseverazione_sisma_2',
	TRASMISSIONE_ASSEVERAZIONE_Sisma_3: 'trasmissione_asseverazione_sisma_3',
	WEBFORM_110_2: 'webform_110_2',
	WEBFORM_110_3: 'webform_110_3',
	WEBFORM_Sisma_2: 'webform_sisma_2',
	WEBFORM_Sisma_3: 'webform_sisma_3',

	AUTODICHIARAZIONE_BENEFICIARIO_50: 'autodichiarazione_beneficiario_50', //verifica_autodichiarazione_beneficiario_50
	DETTAGLIO_IMPORTI_50: 'dettaglio_importi_50', //verifica_dettaglio_importi_50
	AUTODICHIARAZIONE_IMPRESA_ESECUTRICE_50: 'autodichiarazione_impresa_esecutrice_50', //verifica_autodichiarazione_impresa_esecutrice_50
	DICHIARAZIONE_CONFORMITA_50: 'dichiarazione_conformita_50', //verifica_dichiarazione_conformita_50
	COMUNICAZIONE_ASL_50: 'comunicazione_asl_50', //verifica_comunicazione_asl_50
	CAMPO_IBAN_50: 'campo_iban_50', //verifica_campo_iban_50
	ASSEVERAZIONE_50: 'asseverazione_50', //verifica_asseverazione_50
	TABELLA_IMPORTI_50: 'tabella_importi_50', //verifica_tabella_importi_50
	ANAGRAFICA_UNITA_BENEFICIARI_50: 'anagrafica_unita_beneficiari_50', //verifica_anagrafica_unita_beneficiari_50
	DICHIARAZIONE_BARRIERE_50: 'dichiarazione_barriere_50', //verifica_dichiarazione_barriere_50
	FATTURE_50: 'fatture_50', //verifica_fatture_50
	BONIFICI_50: 'bonifici_50', //verifica_bonifici_50
	ASSEVERAZIONE_CONGRUITA_50: 'asseverazione_congruita_50', //verifica_asseverazione_congruita_50
	TECNICO_ASSEVERATORE_50: 'tecnico_asseveratore_50', //verifica_tecnico_asseveratore_50
	POLIZZA_RC_50: 'polizza_rc_50', //verifica_polizza_rc_50
	VERBALE_CONSEGNA_50: 'verbale_consegna_50', //verifica_verbale_consegna_50
	LETTERA_INCARICO_DIRETTORE_50: 'lettera_incarico_direttore_50', //verifica_lettera_incarico_direttore_50
	ANTIFRODE_50: 'antifrode_50', //verifica_antifrode_50
	FOTO_POSTLAVORI_50: 'foto_postlavori_50', //verifica_foto_postlavori_50
	DICHIARAZIONE_ESONERO_50: 'dichiarazione_esonero_50', //verifica_dichiarazione_esonero_50
	WEBFORM_50: 'webform_50', //verifica_webform_50
	DELEGA_TRASFERIMENTO_BANCA_50: 'delega_trasferimento_banca_50', //verifica_delega_trasferimento_banca_50
	FILE_OPZIONE_SCONTO_50: 'file_opzione_sconto_50', //verifica_file_opzione_sconto_50
	COMPUTO_METRICO_50: 'computo_metrico_50', //verifica_computo_metrico_50
	MODELLO_OPZIONE_SCONTO_50: 'modello_opzione_sconto_50', //verifica_modello_opzione_sconto_50
	MODELLO_OPZIONE_SCONTO_FIRMATO_50: 'modello_opzione_sconto_firmato_50', //verifica_modello_opzione_sconto_firmato_50
	RICEVUTA_INVIO_OPZIONE_SCONTO_50: 'ricevuta_invio_opzione_sconto_50', //verifica_ricevuta_invio_opzione_sconto_50
	TABELLA_IMPORTI_FINELAVORI_50: 'tabella_importi_finelavori_50', //verifica_tabella_importi_finelavori_50
	DELEGA_TRASFERIMENTO_CREDITO_50: 'delega_trasferimento_credito_50', //verifica_delega_trasferimento_credito_50
	LINK_INSERIMENTO_PIN_50: 'link_inserimento_pin_50', //verifica_link_inserimento_pin_50
	ATTESTAZIONE_TRASFERIMENTO_50: 'attestazione_trasferimento_50', //verifica_attestazione_trasferimento_50
	CONDIZIONI_SOSPENSIVE_50: 'condizioni_sospensive_50' //verifica_condizioni_sospensive_50
};

export const TABS = {
	WORKFLOW: 'workflow',
	INDEX: 'index',
	OWNER: 'owner',
	CONDOMINIUM: 'condominium',
	HOUSING: 'housing',
	GENERAL: 'general',
	SPECIFIC: 'specific',
	FIXTURES: 'fixtures',
	INSTALLATIONS: 'installations',
	CONTRACTS: 'contracts',
	OTHER: 'other',
	ATTACHMENTS: 'attachments',
	BACKOFFICE: 'backoffice',
	DETAILS: 'details',
	SMOBILIZZO: 'smobilizzo',
	CRONOLOGIA: 'cronologia'
};

export const CONSTANT_KEYS = {
	BE_APP_NAME: 'appName',
	BE_APP_ICON: 'appIcon',
	BE_GMAPS_KEY: 'appGoogleMapsApiKey',
	BE_AGENCY_STYLE: 'clientAgencyStyle',
	BE_CONTRACT_MULTILINE: 'appContractMultiline',
	BE_CONTRACT_SUPPLY_INVOICE: 'appContractSupplyInvoice',
	BE_CONTRACT_AGENCY_MODE: 'appContractAgencyMode',
	BE_USERNAME_GENERATION: 'usernameGeneration',
	BE_RELATIONS_CUSTOMER_TYPE_TYPOLOGY_USE:
		'appRelationsCustomerTypeTypologyUse',
	BE_ECOBONUS_GDPR: 'appEcobonusGdpr',
	CONTRACT: 'contract',
	PRECONTRACT: 'precontract',
	BPARTNER: 'bpartner',
	APP_CODE: 'appCode',
	PRIVACY_URL: 'appPrivacyUrl',
	CUSTOMER_TRANSLATION:'customerTranslation',
	URL_GOOGLE_PLAY_APP:'urlGoogleApp',
	URL_APPLE_APP:'urlAppleApp',
};

export const CONSTANT_CALENDAR = {
	typeList: [
		{
			id: 'apt',
			value: 'APPUNTAMENTO',
			default: true
		},
		{
			id: 'tkt',
			value: 'SUPPORTO',
			default: false
		},
		{
			id: 'chat',
			value: 'GENERALE',
			default: false
		}
	],
	statusList: [
		{
			id: 'draft',
			value: 'BOZZA',
			color: 'primary'
		},
		{
			id: 'work',
			value: 'IN LAVORAZIONE',
			color: 'success'
		}
	]
};

export const TYPES = [
	{
		code: 'text'
	},
	{
		code: 'data'
	},
	{
		code: 'rest'
	},
	{
		code: 'enum'
	}
];

export const ENUM_STATUS = [
	{
		label: 'APERTO',
		code: 'open'
	},
	{
		label: 'COMPLETATO',
		code: 'close'
	}
];

export const ENUM_STATUS_WORKFLOW = [
	{
		label: 'IN ESECUZIONE',
		code: 'OPEN'
	},
	{
		label: 'TERMINATO',
		code: 'CLOSE'
	},
	{
		label: 'BOZZA',
		code: 'DRAFT'
	}
];

export const ENUM_TYPE_IMMO = [
	{
		label: 'Condomini (tutti)',
		code: 'C'
	},
	{
		label: 'Condomini (da 2 a 8)',
		code: 'D'
	},
	{
		label: 'Condomini (oltre 8)',
		code: 'E'
	},
	{
		label: 'Unità imm. funzionalmente ind.',
		code: 'V'
	},
	{
		label: 'Edificio residenz. unifamiliare',
		code: 'U'
	}
];

export const ENUM_STATUS_OPPORTUNITY = [
	{
		label: 'APERTO',
		code: 'OPEN'
	},
	{
		label: 'CHIUSO',
		code: 'CLOSE'
	}
];

export const ENUM_TOBECHECK = [
	{
		label: 'SI',
		code: true
	},
	{
		label: 'NO',
		code: false
	}
];

export const ENUM_STATUS_LEADS = [
	{
		label: 'APERTO',
		code: 'OPEN'
	},
	{
		label: 'CHIUSO',
		code: 'CLOSE'
	}
];

export const ENUM_STATUS_CAMPAIGNS = [
	{
		label: 'APERTA',
		code: 'OPEN'
	},
	{
		label: 'CHIUSA',
		code: 'CLOSE'
	}
];

export const ENUM_STATUS_CAMPAIGN_ELEMS = [
	{
		label: 'KO',
		code: 'FAILED'
	},
	{
		label: 'Fissato appuntamento',
		code: 'APPOINTMENT'
	},
	{
		label: 'Bozza',
		code: 'DRAFT'
	},
	{
		label: 'Da richiamare',
		code: 'RECALL'
	}
];

export const ENUM_TYPE_LEADS = [
	{
		label: 'PRIVATO',
		code: 'P'
	},
	{
		label: 'AZIENDA',
		code: 'C'
	}
];

export const ENUM_PAYMENT = [
	{
		label: 'DA PAGARE',
		code: 'KO'
	},
	{
		label: 'DA STORNARE',
		code: 'DS'
	},
	{
		label: 'PAGATO',
		code: 'OK'
	},
	{
		label: 'STORNATO',
		code: 'ST'
	}
];

export const ENUM_TYPOLOGY_BPARTNER = [
	{
		label: 'PERSONA FISICA',
		code: 'PF'
	},
	{
		label: 'PERSONA GIURIDICA',
		code: 'PG'
	},
	{
		label: 'AMM. DI CONDOMINIO',
		code: 'AC'
	},
	{
		label: 'CONDOMINIO',
		code: 'CC'
	},
	{
		label: 'STUDIO AMM. DI CONDOMINIO',
		code: 'SA'
	}
]

export const ENUM_STATUS_CONTRACT = [
	{
		label: 'ATTIVATO',
		code: 'ATTIVATO'
	},
	{
		label: 'IN LAVORAZIONE',
		code: 'IN LAVORAZIONE'
	},
	{
		label: 'INSERITO FORNITORE',
		code: 'INSERITO FORNITORE'
	},
	{
		label: 'KO FORNITORE',
		code: 'KO FORNITORE'
	},
	{
		label: 'OBSOLETO',
		code: 'OBSOLETO'
	},
	{
		label: 'RECEDUTO',
		code: 'RECEDUTO'
	},
	{
		label: 'VOLTURATO',
		code: 'VOLTURATO'
	}
];
export const ENUM_SUPPLY = [
	{
		label: 'POD',
		code: 'POD'
	},
	{
		label: 'PDR',
		code: 'PDR'
	}
];
export const ENUM_PERCENTAGE_OFF = [
	{
		label: '110%',
		code: '110'
	},
	{
		label: '50/65%',
		code: '50/65'
	}
];

export const ENUM_PRECONTRACT_STATUS_PIPELINE = [
	{
		label: 'APPROVATO',
		code: 'S'
	},
	{
		label: 'RIFIUTATO',
		code: 'F'
	},
	{
		label: 'SOSPESO',
		code: 'H'
	},
	{
		label: 'IN LAVORAZIONE',
		code: 'W'
	},
	{
		label: 'DA LAVORARE',
		code: 'WORKING'
	}
];
export const ENUM_INSPECTION_STATUS_PIPELINE = [
	{
		label: 'IN LAVORAZIONE',
		code: 'W'
	},
	{
		label: 'COMPLETATO',
		code: 'S'
	},
	{
		label: 'DA LAVORARE',
		code: 'WORKING'
	}
];
export const ENUM_INSPECTION = [
	{
		code: 'verifica-documento',
		label: 'VERIFICA DOCUMENTO',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	},
	{
		code: 'verifica-tecnica',
		label: 'VERIFICA TECNICA',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	},
	{
		code: 'firma-pre-contratto',
		label: 'FIRMA PRE CONTRATTO',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	},
	{
		code: 'ape-smart',
		label: 'APE SMART',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	},
	{
		code: 'firma-contratto',
		label: 'FIRMA CONTRATTO',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	},
	{
		code: 'realizzazione',
		label: 'REALIZZAZIONE',
		status: [
			{
				label: 'IN LAVORAZIONE',
				code: 'W'
			},
			{
				label: 'COMPLETATO',
				code: 'S'
			}
		]
	}
];
export const TYPES_PARTNER = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text'
	},
	{
		label: 'Partita IVA',
		name: 'vatCode',
		type: 'text'
	},
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	}
];
export const TYPES_CUSTOMER = [
	{
		label: 'Nome',
		name: 'personFirstName',
		type: 'text'
	},
	{
		label: 'Cognome',
		name: 'personLastName',
		type: 'text'
	},
	{
		label: 'Nickname',
		name: 'nickname',
		type: 'text'
	},
	{
		label: 'Denominazione Cliente',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Tipologia Cliente',
		name: 'type',
		type: 'enum',
		values: [
			{ code: 'PG', label: 'AZIENDA' },
			{ code: 'PF', label: 'PERSONA FISICA' },
			{ code: 'AC', label: 'AMM. CONDOMINIO' },
			{ code: 'CC', label: 'CONDOMINIO' },
			{ code: 'SA', label: 'STUDIO AMM.CONDOMINIO' }
		]
	},
	{
		label: 'Da verificare',
		name: 'toBeCheck',
		type: 'enum',
		values: ENUM_TOBECHECK,
		defaultOperator: 'like'
	},
	{
		label: 'Partita IVA',
		name: 'vatCode',
		type: 'text'
	},
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Città',
		name: 'legalPlace',
		type: 'text'
	},
	{
		label: 'Telefono',
		name: 'phone',
		type: 'text'
	},
	{
		label: 'Agenzia/Agente',
		name: 'assignedAgent',
		type: 'text'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Classificazione',
		name: 'classification',
		type: 'text'
	},
	{
		label: 'Appuntamento terminato',
		name: 'lastTask',
		type: 'date'
	},
	{
		label: 'Ultima variazione stato',
		name: 'lastStatusModification',
		type: 'date'
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				label: 'CESSATO',
				code: 'CESSATO'
			},
			{
				label: 'CLIENTE',
				code: 'CLIENTE'
			},
			{
				label: 'CONTATTO',
				code: 'CONTATTO'
			},
			{
				label: 'EX CLIENTE',
				code: 'EX CLIENTE'
			}
		]
	}
];

export const TYPES_LEADS = [
	{
		label: 'Nome',
		name: 'firstName',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Cognome',
		name: 'lastName',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Ragione Sociale',
		name: 'companyName',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Creato da',
		name: 'createdBy',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Cliente Creato',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS_LEADS
	},
	{
		label: 'Tag',
		name: 'tag',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Tipo',
		name: 'type',
		type: 'enum',
		values: ENUM_TYPE_LEADS
	}
];

export const TYPES_CAMPAIGNS = [
	{
		label: 'Tipologia campagna',
		name: 'campaignTypology',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Agente',
		name: 'agent',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Data inizio campagna',
		name: 'campaignBeginDate',
		type: 'date'
	},
	{
		label: 'Data fine campagna',
		name: 'campaignEndDate',
		type: 'date'
	},
	{
		label: 'Data soglia scadenza',
		name: 'campaignExpiryDate',
		type: 'date'
	},
	{
		label: 'Fornitore',
		name: 'campaignSupplier',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Superata scadenza',
		name: 'expired',
		type: 'enum',
		values: [
			{
				label: 'SI',
				code: 'Y'
			},
			{
				label: 'NO',
				code: 'N'
			}
		]
	}
];

export const TYPES_CAMPAIGN_ALL_ELEMS = [
	{
		label: 'Tipologia campagna',
		name: 'campaignTypology',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Agente',
		name: 'agent',
		type: 'text',
		defaultOperator: 'like',
		default: true
	},
	{
		label: 'Nome Campagna',
		name: 'campaign',
		type: 'text',
		defaultOperator: 'like',
		default: true
	},
	{
		label: 'Nome Cliente',
		name: 'bpartnerName',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Nome Potenziale Cliente',
		name: 'leadName',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente',
		name: 'address',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (Comune)',
		name: 'city',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (Provincia)',
		name: 'province',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (CAP)',
		name: 'cap',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Esito Azione',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS_CAMPAIGN_ELEMS
	},
	{
		label: 'Stato Campagna',
		name: 'campaignStatus',
		type: 'enum',
		values: ENUM_STATUS_CAMPAIGNS
	},
	{
		label: 'Superata Scadenza',
		name: 'expired',
		type: 'enum',
		values: [
			{
				label: 'SI',
				code: 'Y'
			},
			{
				label: 'NO',
				code: 'N'
			}
		]
	},
	{
		label: 'Data Soglia Scadenza',
		name: 'campaignExpiryDate',
		type: 'date'
	},
	{
		label: 'C.F. Cliente',
		name: 'fiscalCode',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'C.F. Potenziale Cliente',
		name: 'fiscalCodeLead',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'P.IVA Cliente',
		name: 'vatCode',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'P.IVA Potenziale Cliente',
		name: 'vatCodeLead',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Classificazione Cliente',
		name: 'classification',
		type: 'text'
	},
	{
		label: 'Fornitore',
		name: 'campaignSupplier',
		type: 'text',
		defaultOperator: 'like'
	}
];

export const TYPES_CAMPAIGN_ELEMS = [
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS_CAMPAIGN_ELEMS,
		default: true
	},
	{
		label: 'Nome Cliente',
		name: 'bpartnerName',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Nome Potenziale cliente',
		name: 'leadName',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente',
		name: 'address',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'C.F. Cliente',
		name: 'fiscalCode',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'C.F. Potenziale Cliente',
		name: 'fiscalCodeLead',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'VAT Cliente',
		name: 'vatCode',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'VAT Potenziale Cliente',
		name: 'vatCodeLead',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (Comune)',
		name: 'city',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (Provincia)',
		name: 'province',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Indirizzo Cliente (CAP)',
		name: 'cap',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Classificazione Cliente',
		name: 'classification',
		type: 'text'
	}
];

export const TYPES_CAMPAIGN_BP_ELEMS = [
	{
		label: 'Nome Campagna',
		name: 'campaign',
		type: 'text',
		defaultOperator: 'like',
		default: true
	},
	{
		label: 'Esito Azione',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS_CAMPAIGN_ELEMS
	},
	{
		label: 'Superata Scadenza',
		name: 'expired',
		type: 'enum',
		values: [
			{
				label: 'SI',
				code: 'Y'
			},
			{
				label: 'NO',
				code: 'N'
			}
		]
	},
	{
		label: 'Data Soglia Scadenza',
		name: 'campaignExpiryDate',
		type: 'date'
	}
];

export const TYPES_OPPORTUNITY = [
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS_OPPORTUNITY
	},
	{
		label: 'P.IVA',
		name: 'vat',
		type: 'text'
	},
	{
		label: 'Agente/Agenzia cliente',
		name: 'agent',
		type: 'text'
	},
	{
		label: 'Nome Cliente',
		name: 'customer',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	}
];

export const TYPES_PRECONTRACT = [
	{
		label: 'Agenzia',
		name: 'agency',
		type: 'text'
	},
	{
		label: 'P.IVA',
		name: 'vat',
		type: 'text'
	},
	{
		label: 'Agente',
		name: 'agent',
		type: 'text'
	},
	{
		label: 'Nome Cliente',
		name: 'customer',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Tipologia Pre-Contratto',
		name: 'conclStartType',
		type: 'enum',
		values: [
			{ code: 'NUOVO ALLACCIO', label: 'NUOVO ALLACCIO' },
			{
				code: 'ALLACCIO E CONT',
				label: 'NUOVO ALLACCIO E POSA CONTATORE'
			},
			{ code: 'SUBENTRO', label: 'SUBENTRO' },
			{ code: 'SWITCH-IN', label: 'SWITCH-IN' },
			{ code: 'VOLTURA', label: 'VOLTURA' }
		]
	},
	{
		label: 'Stato Pre-Contratto',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS
	},
	{
		label: 'Stato workflow',
		name: 'statusWorkflow',
		type: 'enum',
		values: ENUM_STATUS_WORKFLOW
	},
	{
		label: 'POD',
		name: 'pod',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'PDR',
		name: 'pdr',
		type: 'text',
		defaultOperator: 'like'
	},
	{
		label: 'Credit Check',
		name: 'credit-check',
		type: 'pipeline',
		values: ENUM_PRECONTRACT_STATUS_PIPELINE
	},
	{
		label: 'Quality Check',
		name: 'quality-check',
		type: 'pipeline',
		values: ENUM_PRECONTRACT_STATUS_PIPELINE
	},
	{
		label: 'Validazione',
		name: 'validazione',
		type: 'pipeline',
		values: ENUM_PRECONTRACT_STATUS_PIPELINE
	},
	{
		label: 'Switch in',
		name: 'switch-in',
		type: 'pipeline',
		values: ENUM_PRECONTRACT_STATUS_PIPELINE
	},
	{
		label: 'Welcome',
		name: 'welcome',
		type: 'pipeline',
		values: ENUM_PRECONTRACT_STATUS_PIPELINE
	}
];

export const TYPES_INSPECTION = [
	{
		label: 'Agenzia',
		name: 'agency',
		type: 'text'
	},
	{
		label: 'Agente',
		name: 'agent',
		type: 'text'
	},
	{
		label: 'CILA',
		name: 'cila',
		type: 'enum',
		values: [
			{
				code: "y",
				label: 'SI'
			}
		]
	},
	{
		label: 'Creato da',
		name: 'createdBy',
		type: 'text'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Nome committente',
		name: 'customerFirstName',
		type: 'text'
	},
	{
		label: 'Cognome committente',
		name: 'customerLastName',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: '% Contributo',
		name: 'percentageOff',
		type: 'enum',
		values: ENUM_PERCENTAGE_OFF
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: ENUM_STATUS
	},
	{
		label: 'Tipologia immobile',
		name: 'typeImmo',
		type: 'enum',
		values: ENUM_TYPE_IMMO
	},
	{
		label: 'Indirizzo immobile',
		name: 'address',
		type: 'text'
	},
	{
		label: 'Verifica documento',
		name: 'verifica-documento',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	},
	{
		label: 'Verifica tecnica',
		name: 'verifica-tecnica',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	},
	{
		label: 'Firma pre-contratto',
		name: 'firma-pre-contratto',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	},
	{
		label: 'APE Smart',
		name: 'ape-smart',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	},
	{
		label: 'Firma contratto',
		name: 'firma-contratto',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	},
	{
		label: 'Realizzazione',
		name: 'realizzazione',
		type: 'pipeline',
		values: ENUM_INSPECTION_STATUS_PIPELINE
	}
];

export const TYPES_CONTRACT = [
	{
		label: 'N° Contratto',
		name: 'contractNo',
		type: 'text',
		default: true,
		defaultOperator: 'like',
		customOperators: ['like', 'startWith']
	},
	{
		label: 'Tipo Fornitura',
		name: 'supply',
		type: 'enum',
		values: ENUM_SUPPLY
	},
	{
		label: 'POD',
		name: 'pod',
		type: 'text'
	},
	{
		label: 'PDR',
		name: 'pdr',
		type: 'text'
	},
	{
		label: 'Stato Lavorazione',
		name: 'workingStates',
		type: 'enum',
		values: ENUM_STATUS_CONTRACT
	},
	{
		label: 'Firmatario',
		name: 'signatory',
		type: 'text'
	},
	{
		label: 'Agenzia/Agente',
		name: 'sellerName',
		type: 'text'
	},
	{
		label: 'Denominazione Cliente',
		name: 'customerName',
		type: 'text'
	},
	{
		label: 'Partita IVA',
		name: 'piva',
		type: 'text'
	},
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Data inserimento contratto',
		name: 'contractDateInsertUser',
		type: 'date'
	},
	{
		label: 'Data inserimento linea',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica linea',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Data stipula contratto',
		name: 'contractDate',
		type: 'date'
	},
	{
		label: 'Data Inizio Fornitura',
		name: 'startDate',
		type: 'date'
	},
	{
		label: 'Codice cliente',
		name: 'customerCode',
		type: 'text'
	},
	{
		label: 'Venditore',
		name: 'workspaceName',
		type: 'text'
	},
	{
		label: 'Pagamento provvigione',
		name: 'feePaymentStatus',
		type: 'enum',
		values: ENUM_PAYMENT
	},
	{
		label: 'Tipologia offerta (listino)',
		name: 'priceList',
		type: 'text'
	},
	{
		label: 'Tipologia (cliente)',
		name: 'typologyBPartner',
		type: 'enum',
		values: ENUM_TYPOLOGY_BPARTNER
	},
	{
		label: 'Tipologia clientela',
		name: 'customerType',
		type: 'enum',
		values: [
			{ code: 'B', label: 'BUSINESS' },
			{ code: 'D', label: 'DOMESTICI' },
			{ code: 'C', label: 'CONDOMINI' }
		]
	},
	{
		label: 'Provvigione (data)',
		name: 'dateCommission',
		type: 'date',
		defaultOperator: '=',
		customOperators: ['=']
	}
];

export const TYPES_CONTRACT_NOLINES = [
	{
		label: 'N° Contratto',
		name: 'contractNo',
		type: 'text',
		default: true,
		defaultOperator: 'like',
		customOperators: ['like', 'startWith']
	},
	{
		label: 'Stato Lavorazione',
		name: 'workingStates',
		type: 'enum',
		values: ENUM_STATUS_CONTRACT
	},
	{
		label: 'Firmatario',
		name: 'signatory',
		type: 'text'
	},
	{
		label: 'Agenzia/Agente',
		name: 'sellerName',
		type: 'text'
	},
	{
		label: 'Denominazione Cliente',
		name: 'customerName',
		type: 'text'
	},
	{
		label: 'Partita IVA',
		name: 'piva',
		type: 'text'
	},
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Data inserimento contratto',
		name: 'contractDateInsertUser',
		type: 'date'
	},
	{
		label: 'Data stipula contratto',
		name: 'contractDate',
		type: 'date'
	},
	{
		label: 'Data Inizio Fornitura',
		name: 'startDate',
		type: 'date'
	},
	{
		label: 'Codice cliente',
		name: 'customerCode',
		type: 'text'
	},
	{
		label: 'Venditore',
		name: 'workspaceName',
		type: 'text'
	},
	{
		label: 'Tipologia cliente',
		name: 'typologyBPartner',
		type: 'enum',
		values: ENUM_TYPOLOGY_BPARTNER
	}
];

export const TYPES_CONTACT = [
	{
		label: 'Nome',
		name: 'firstName',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Telefono',
		name: 'phoneNo1',
		type: 'text'
	},
	{
		label: 'Cellulare',
		name: 'cellNo1',
		type: 'text'
	},
	{
		label: 'Email',
		name: 'email',
		type: 'text'
	}
];

export const TYPES_INVOICE = [
	{
		label: 'Numero Fattura',
		name: 'no',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_ACTIVITY = [
	{
		label: 'Titolo',
		name: 'title',
		type: 'text'
	},
	{
		label: 'Assegnatario',
		name: 'assegnee',
		type: 'text'
	},
	{
		label: 'Tipo',
		name: 'tipology',
		type: 'enum',
		values: [
			{
				code: 'apt',
				label: 'Appuntamento'
			},
			{
				code: 'tkt',
				label: 'Ticket'
			},
			{
				code: 'chat',
				label: 'Chat'
			}
		]
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				label: 'IN LAVORAZIONE',
				code: 'work'
			},
			{
				label: 'TERMINATO',
				code: 'end'
			},
			{
				label: 'BOZZA',
				code: 'draft'
			}
		]
	}
];

export const TYPES_AGENT = [
	{
		label: 'Nome',
		name: 'personFirstname',
		type: 'text'
	},
	{
		label: 'Cognome',
		name: 'personLastname',
		type: 'text'
	},
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Partita IVA',
		name: 'vatCode',
		type: 'text'
	},
	{
		label: 'Nome completo',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_AGENCY = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	,
	{
		label: 'Codice fiscale',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Partita IVA',
		name: 'vatCode',
		type: 'text'
	}
];

export const TYPES_POD_PDR = [
	{
		label: 'Codice',
		name: 'podPdr',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'N° Contratto',
		name: 'contractNo',
		type: 'text'
	},
	{
		label: 'Nome cliente',
		name: 'name',
		type: 'text'
	},
	{
		label: 'Codice cliente',
		name: 'code',
		type: 'text'
	},
	{
		label: 'Codice fiscale cliente',
		name: 'fiscalCode',
		type: 'text'
	},
	{
		label: 'Partita IVA cliente',
		name: 'vatCode',
		type: 'text'
	}
];

export const TYPES_PRICE_LIST = [
	{
		label: 'Sistema',
		name: 'energyType',
		type: 'enum',
		values: [
			{
				label: 'Energia',
				code: 'E'
			},
			{
				label: 'Gas',
				code: 'G'
			}
		]
	},
	{
		label: 'Tipo',
		name: 'priceListType',
		type: 'text'
	},
	{
		label: 'Venditore',
		name: 'workspaceName',
		type: 'text'
	},
	{
		label: 'Nome',
		name: 'priceList',
		type: 'text'
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				label: 'Attivo',
				code: 'active',
				default: true
			},
			{
				label: 'Scaduto',
				code: 'inactive'
			}
		],
		default: true,
		defaultOperator: '='
	}
];

export const TYPES_TICKET = [
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				code: 'OPEN',
				label: 'APERTO'
			},
			{
				code: 'CLOSE',
				label: 'CHIUSO'
			},
			{
				code: 'DRAFT',
				label: 'BOZZA'
			}
		]
	},
	{
		label: 'Assegnazione',
		name: 'assign',
		type: 'enum',
		values: [
			{
				label: 'Assegnati a me',
				code: 'me'
			},
			{
				label: 'Tutte le assegnazioni',
				code: 'all'
			}
		]
	},
	{
		label: 'Cognome (Assegnatario)',
		name: 'lastNameAss',
		type: 'text'
	},
	{
		label: 'Nome (Assegnatario)',
		name: 'firstNameAss',
		type: 'text'
	},
	{
		label: 'Cognome (Reporter)',
		name: 'lastNameRep',
		type: 'text'
	},
	{
		label: 'Nome (Reporter)',
		name: 'firstNameRep',
		type: 'text'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text'
	},
	{
		label: 'Workflow',
		name: 'storyboard.name',
		type: 'text'
	},
	{
		label: 'Nome Workspace',
		name: 'workspace.name',
		type: 'text'
	},
	{
		label: 'Scaduti',
		name: 'expired',
		type: 'enum',
		values: [
			{
				label: 'SI',
				code: true
			}
		]
	},
	{
		label: 'Data creazione',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data scadenza',
		name: 'expireDate',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Tipologia',
		name: 'typeName',
		type: 'text'
	},
	{
		label: 'Cliente',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_TODO = [
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				code: 'work',
				label: 'APERTO'
			},
			{
				code: 'end',
				label: 'COMPLETATO'
			}
		]
	},
	{
		label: 'Titolo',
		name: 'title',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Cognome (Assegnatario)',
		name: 'lastNameAss',
		type: 'text'
	},
	{
		label: 'Nome (Assegnatario)',
		name: 'firstNameAss',
		type: 'text'
	},
	{
		label: 'Cognome (Reporter)',
		name: 'lastNameRep',
		type: 'text'
	},
	{
		label: 'Nome (Reporter)',
		name: 'firstNameRep',
		type: 'text'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text'
	},
	{
		label: 'Workflow',
		name: 'storyboard.name',
		type: 'text'
	},
	{
		label: 'Nome Reparto',
		name: 'workspace.name',
		type: 'text'
	},
	{
		label: 'Data creazione',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Cliente',
		name: 'customer',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_FUNCTIONDEFINITION = [
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Chiave',
		name: 'key',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_GROUPS = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_USER = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Email',
		name: 'mail',
		type: 'text'
	},
	{
		label: 'UserId',
		name: 'id',
		type: 'text'
	},
	{
		label: 'Gruppo',
		name: 'group',
		type: 'text'
	},
	{
		label: 'Ruolo',
		name: 'auth',
		type: 'enum',
		values: [
			{ code: 'ROLE_USER', label: 'Utente' },
			{ code: 'ROLE_ADMINISTRATOR', label: 'Amministratore di sistema' },
			{ code: 'ROLE_SUPERVISOR', label: 'Supervisore di sistema' },
			{ code: 'ROLE_AGENCY', label: 'Ruolo Agenzia' },
			{ code: 'ROLE_AGENT', label: 'Ruolo Agente' },
			{ code: 'ROLE_BACKOFFICE', label: 'Ruolo Backoffice' }
		]
	},
	{
		label: 'Stato',
		name: 'enabled',
		type: 'enum',
		values: [
			{
				label: 'ATTIVO',
				code: true
			},
			{
				label: 'NON ATTIVO',
				code: false
			}
		]
	}
];

export const TYPES_TAG = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_TEMPLATE = [
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_TEMPLATE_MESSAGE = [
	{
		label: 'Titolo',
		name: 'title',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Messaggio',
		name: 'body',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Mailbox',
		name: 'mailbox.name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_REPORT_DEFINITIONS = [
	{
		label: 'Codice',
		name: 'code',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Creato da',
		name: 'createdBy',
		type: 'text'
	},
	{
		label: 'Modificato da',
		name: 'modifiedBy',
		type: 'text'
	}
];

export const TYPES_REPORT_PARAMETERS = [
	{
		label: 'Codice',
		name: 'code',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Nome',
		name: 'name',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Definizione',
		name: 'definition',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Data inserimento',
		name: 'created',
		type: 'date'
	},
	{
		label: 'Data modifica',
		name: 'modified',
		type: 'date'
	},
	{
		label: 'Creato da',
		name: 'createdBy',
		type: 'text'
	},
	{
		label: 'Modificato da',
		name: 'modifiedBy',
		type: 'text'
	}
];

export const TYPES_TENANT = [
	{
		label: 'Nome',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text'
	},
	{
		label: 'Stato',
		name: 'enabled',
		type: 'enum',
		values: [
			{
				label: 'ATTIVO',
				code: true
			},
			{
				label: 'NON ATTIVO',
				code: false
			}
		]
	}
];

export const TYPES_WORKSPACE = [
	{
		label: 'Nome',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text'
	},
	{
		label: 'Stato',
		name: 'enabled',
		type: 'enum',
		values: [
			{
				label: 'ATTIVO',
				code: true
			},
			{
				label: 'NON ATTIVO',
				code: false
			}
		]
	}
];

export const TYPES_MAILBOX = [
	{
		label: 'Nome',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Stato',
		name: 'enabled',
		type: 'enum',
		values: [
			{
				label: 'ATTIVO',
				code: true
			},
			{
				label: 'NON ATTIVO',
				code: false
			}
		]
	}
];

export const TYPES_STORYBOARD = [
	{
		label: 'Nome',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	{
		label: 'Descrizione',
		name: 'description',
		type: 'text'
	},
	{
		label: 'Stato',
		name: 'status',
		type: 'enum',
		values: [
			{
				label: 'ATTIVO',
				code: 'ACTIVE'
			},
			{
				label: 'NON ATTIVO',
				code: 'INACTIVE'
			},
			{
				label: 'BOZZA',
				code: 'DRAFT'
			}
		]
	}
];

export const TYPES_PRICE_LINES = [
	{
		label: 'Tipo linea',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_COEFFICENTS = [
	{
		label: 'Coefficiente',
		name: 'spotlight',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	}
];

export const TYPES_TASK = [
	{
		label: 'Titolo',
		name: 'subject',
		type: 'text',
		default: true,
		defaultOperator: 'like'
	},
	// {
	// 	label: 'Stato',
	// 	name: 'status',
	// 	type: 'enum',
	// 	values: [
	// 		{
	// 			code: 'OPEN',
	// 			label: 'APERTO'
	// 		},
	// 		{
	// 			code: 'CLOSE',
	// 			label: 'CHIUSO'
	// 		},
	// 		{
	// 			code: 'DRAFT',
	// 			label: 'BOZZA'
	// 		}
	// 	]
	// },
	{
		label: 'Assegnazione',
		name: 'assign',
		type: 'enum',
		values: [
			{
				label: 'Assegnati a me',
				code: 'me'
			},
			{
				label: 'Tutte le assegnazioni',
				code: 'all'
			}
		]
	},
	{
		label: 'Storyboard',
		name: 'storyboard.name',
		type: 'text'
	}
];

export const TYPES_MAILS = [
	{
		label: 'Oggetto',
		name: 'subject',
		type: 'text'
	},
	{
		label: 'Mittente',
		name: 'from',
		type: 'text'
	},
	{
		label: 'Destinatario',
		name: 'to',
		type: 'text'
	}
];

export const RENOVATIONS = [
	{
		id: 'CT',
		value: 'Cappotto termico'
	},
	{
		id: 'GT',
		value: 'Guaina tetto'
	},
	{
		id: 'RF',
		value: 'Rifacimento facciate'
	},
	{
		id: 'RII',
		value: 'Rifacimento impianti idrici'
	},
	{
		id: 'RIE',
		value: 'Rifacimento impianti elettrici'
	},
	{
		id: 'RT',
		value: 'Rifacimento tetto'
	},
	{
		id: 'SI',
		value: 'Sostituzione infissi'
	},
	{
		id: 'SPI',
		value: 'Sostituzione pavimenti interni'
	}
];
